import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import { FjSelect } from 'components/primitives';
import { selectUserIsTabbing } from 'selectors/ui';

type FjSelectComponentProps = React.ComponentProps<typeof FjSelect>;

interface StyledSelectProps extends FjSelectComponentProps {
  isTabbing?: boolean;
}

// `?? props.x` preserves overrides from a consumer doing `styled(Select).attrs(...)`
// (e.g. cost-center-selector's dark-header CCSelect). Before the connect->hooks migration,
// react-redux's connect() HOC hoisted FjSelect's styled-components statics onto the
// exported Select, so styled-components treated it as the same component chain and let
// the outer attrs win. The plain function wrapper below no longer carries those statics,
// so these attrs must defer to already-passed-in props instead of hardcoding values.
const StyledSelect = styled(FjSelect).attrs<StyledSelectProps>((props) => ({
  bgColor: props.bgColor ?? props.theme.colors.white,
  disabledOptionColor: props.disabledOptionColor ?? props.theme.colors.notSelectable,
  dropdownBgColor: props.dropdownBgColor ?? props.theme.colors.white,
  selectedValueColor: props.selectedValueColor ?? props.theme.colors.selectableLightBg,
  selectedOptionColor: props.selectedOptionColor ?? props.theme.colors.selectableLightBg,
  selectedBgColor: props.selectedBgColor ?? props.theme.colors.selected,
  outlineOnFocus: props.isTabbing,
}))<StyledSelectProps>`
  font-size: ${({ theme }) => theme.fontSizes.h6};
`;

const Select = (props: FjSelectComponentProps): React.ReactElement => {
  const isTabbing = useSelector(selectUserIsTabbing);
  return <StyledSelect {...props} isTabbing={isTabbing} />;
};

export default Select;
